module.exports = __webpack_public_path__ + "assets/img/index_icon3.13dd9d84.png";